<template>
  <svg
    width="133"
    height="52"
    viewBox="0 0 133 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_166_4546)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M95.7638 34.94C96.9086 34.3618 97.6915 33.2898 97.6915 31.5408C97.6915 28.4236 95.3027 27.4786 92.8995 27.4786H87.4791V38.9317H91.2096V35.5324H92.2295L94.5622 38.9317H98.669L95.7774 34.94H95.7638ZM92.801 32.7262H91.208V30.554H92.801C93.5552 30.554 93.9602 30.9771 93.9602 31.6542C93.9602 32.2607 93.5552 32.7262 92.801 32.7262Z"
        fill="black"
        style="fill: black; fill-opacity: 1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M132.335 38.9319V33.7554H127.335V38.9319H132.335Z"
        fill="black"
        style="fill: black; fill-opacity: 1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M84.7268 13.6001H76.2193V25.0532H79.9632V21.5129H84.4338V18.297H79.9632V16.9006H84.7268V13.6001Z"
        fill="black"
        style="fill: black; fill-opacity: 1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M90.008 13.6001H86.2639V25.0532H90.008V13.6001Z"
        fill="black"
        style="fill: black; fill-opacity: 1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M95.5525 25.0532V21.5975C95.5525 20.991 95.5525 20.3704 95.4548 19.6792L99.3246 25.0532H102.453V13.6001H98.7514V17.0135C98.7514 17.6482 98.7514 18.297 98.8491 18.974L94.9513 13.6001H91.8644V25.0532H95.5525Z"
        fill="black"
        style="fill: black; fill-opacity: 1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M111.297 13.6001H107.344L103.11 25.0532H106.826L107.33 23.5016H111.255L111.758 25.0532H115.516L111.297 13.6001ZM108.209 20.7945L108.977 18.3685C109.103 17.9595 109.215 17.4799 109.285 16.9016C109.383 17.4799 109.495 17.9595 109.62 18.3685L110.417 20.7945H108.195H108.209Z"
        fill="black"
        style="fill: black; fill-opacity: 1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M119.972 13.6001H116.144V25.0532H124.778V21.7527H119.972V13.6001Z"
        fill="black"
        style="fill: black; fill-opacity: 1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M81.2477 27.4786H76.2188V38.9317H79.9626V35.9274H81.2477C84.112 35.9274 86.3327 34.9259 86.3327 31.7242C86.3327 28.5223 84.1256 27.4786 81.2477 27.4786ZM81.2061 32.8532H79.9624V30.5823H81.2061C82.0859 30.5823 82.6446 30.9208 82.6446 31.7107C82.6446 32.5006 82.0859 32.8391 81.2061 32.8391V32.8532Z"
        fill="black"
        style="fill: black; fill-opacity: 1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M103.279 27.6345H99.4095V38.9324H103.279V27.6345Z"
        fill="black"
        style="fill: black; fill-opacity: 1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M110.989 27.1967C107.874 27.1967 104.759 28.9881 104.772 33.3323C104.772 37.4933 107.888 39.1999 111.072 39.1999C112.26 39.1999 113.406 38.9602 114.398 38.5088V35.0391C113.797 35.5609 112.735 35.8712 111.548 35.8712C110.081 35.8712 108.6 35.0955 108.6 33.3183C108.6 31.2731 110.095 30.4973 111.646 30.4973C112.651 30.4973 113.699 30.8217 114.314 31.2871V27.902C113.308 27.4366 112.135 27.1967 110.989 27.1967Z"
        fill="black"
        style="fill: black; fill-opacity: 1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M124.778 27.4786H116.061V38.9317H124.778V35.9556H119.791V34.5451H124.401V31.7947H119.791V30.3983H124.778V27.4786Z"
        fill="black"
        style="fill: black; fill-opacity: 1"
      />
      <path
        d="M64.2071 51.8212H63.9292V43.839V14.5803V0.216309H64.2071V3.19453V30.0363V51.8212Z"
        fill="black"
        style="fill: black; fill-opacity: 1"
      />
      <path
        d="M33.0721 38.5977H19.1001V13.4395H33.0721V38.5977Z"
        fill="#F26521"
        style="
          fill: #f26521;
          fill: color(display-p3 0.949 0.3961 0.1294);
          fill-opacity: 1;
        "
      />
      <path
        d="M19.9869 26.0186C19.9869 20.9146 22.372 16.3693 26.0856 13.4394C23.3695 11.2968 19.9424 10.0186 16.2176 10.0186C7.39932 10.0186 0.250977 17.1822 0.250977 26.0186C0.250977 34.855 7.39932 42.0186 16.2176 42.0186C19.9424 42.0186 23.3695 40.7404 26.0856 38.5977C22.372 35.6679 19.9869 31.1226 19.9869 26.0186Z"
        fill="#E51B24"
        style="
          fill: #e51b24;
          fill: color(display-p3 0.898 0.1059 0.1412);
          fill-opacity: 1;
        "
      />
      <path
        d="M51.4224 35.9334V35.3125H51.2606L51.0747 35.7396L50.8883 35.3125H50.7265V35.9334H50.8408V35.4649L51.0151 35.8685H51.1339L51.3082 35.4636V35.9334H51.4224ZM50.3978 35.9334V35.4183H50.605V35.3134H50.0771V35.4183H50.2844V35.9334H50.3978Z"
        fill="black"
        style="fill: black; fill-opacity: 1"
      />
      <path
        d="M51.9211 26.0186C51.9211 34.855 44.7723 42.0186 35.9539 42.0186C32.2292 42.0186 28.802 40.7404 26.0859 38.5977C29.8 35.6679 32.1847 31.1226 32.1847 26.0186C32.1847 20.9146 29.8 16.3693 26.0859 13.4394C28.802 11.2968 32.2292 10.0186 35.9539 10.0186C44.7723 10.0186 51.9211 17.1822 51.9211 26.0186Z"
        fill="#F99F1B"
        style="
          fill: #f99f1b;
          fill: color(display-p3 0.9765 0.6235 0.1059);
          fill-opacity: 1;
        "
      />
    </g>
    <defs>
      <clipPath id="clip0_166_4546">
        <rect
          width="132.889"
          height="52"
          fill="white"
          style="fill: white; fill-opacity: 1"
        />
      </clipPath>
    </defs>
  </svg>
</template>
